import React from 'react'
import { Link, Outlet } from 'react-router-dom'
import { styled } from '@mui/material'

//components
import MenuItem from './MenuItem'

//assets
import Logo from '../assets/logo.png'
import Logo2 from '../assets/logo-secondary.png'
import { SIDE_PANEL_WIDTH } from '../utils/constants'

import HomeIcon from '@mui/icons-material/Home'
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty'
import CloudSyncIcon from '@mui/icons-material/CloudSync'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import BuildIcon from '@mui/icons-material/Build';

const App = styled('main')(({ theme }) => ({
  width: '100%',
  height: '100vh',
  display: 'flex',
  color: '#424242',
  backgroundColor: '#fff'
}))

const SidePanel = styled('div')(({ theme }) => ({
  width: `${SIDE_PANEL_WIDTH}px`,
  height: '100vh',
  borderRight: '1px solid #dedede'
}))

const SidePanelInner = styled('div')(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  padding: '16px'
}))

const MainContent = styled('div')(({ theme }) => ({
  width: `calc(100% - ${SIDE_PANEL_WIDTH}px)`,
  width: '100%',
  height: '100vh'
}))

const LogoWrapper = styled('img')(({ theme }) => ({
  maxWidth: '100%'
}))

const LogoBox = styled('div')(({ theme, enableMarginTopAuto }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  padding: '0 16px',
  ...(enableMarginTopAuto && { marginTop: 'auto' })
}))

const NavBox = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-start',
  flexDirection: 'column',
  marginTop: '12px'
}))

const MENU_ICON_FONT = 'small'
const SidebarData = [
  {
    title: 'Home',
    path: '/',
    renderIcon: () => {
      return <HomeIcon fontSize={MENU_ICON_FONT} />
    }
  },
  {
    title: 'Manage data',
    path: '/admin',
    renderIcon: () => {
      return <ManageAccountsIcon fontSize={MENU_ICON_FONT} />
    }
  },
  {
    title: 'Shift config',
    path: '/admin/shift-config',
    renderIcon: () => {
      return <HourglassEmptyIcon fontSize={MENU_ICON_FONT} />
    }
  },
  {
    title: 'HMI updates',
    path: '/admin/hmi-update',
    renderIcon: () => {
      return <CloudSyncIcon fontSize={MENU_ICON_FONT} />
    }
  },
  {
    title: 'Tool life',
    path: '/admin/tool-life',
    renderIcon: () => {
      return <BuildIcon fontSize={MENU_ICON_FONT} />
    }
  }
]

const AdminLayout = () => {
  return (
    <App>
      <SidePanel>
        <SidePanelInner>
          <LogoBox>
            <Link to="/">
              <LogoWrapper src={Logo} alt="company logo" />
            </Link>
          </LogoBox>
          <NavBox>
            {SidebarData.map((item, index) => (
              <MenuItem key={index} item={item} />
            ))}
          </NavBox>
          <LogoBox enableMarginTopAuto={true}>
            <Link to="/">
              <LogoWrapper src={Logo2} alt="company logo" />
            </Link>
          </LogoBox>
        </SidePanelInner>
      </SidePanel>
      <MainContent>
        <Outlet />
      </MainContent>
    </App>
  )
}

export default AdminLayout
